export class AuthInfo
 {    
    public UserId:number;
    public Username:string;
    public Password:string;
    
    constructor(){}
}
